// extracted by mini-css-extract-plugin
export default {"container":"oJnui","v-align-middle":"erDIe","button-container":"CJHbo"};